export default __webpack_public_path__ + "static/media/lady-present.30b36c5a.mp4";